import { provideEnvironmentInitializer, inject } from '@angular/core';
import { ProfileClaimsWatcherService } from '@padspin/ui-profile';

/**
 * Provider function to eagerly initialize the ProfileClaimsWatcherService.
 * This ensures the service starts watching for claims changes as soon as the app loads.
 *
 * The service will only activate when a user is authenticated and not anonymous,
 * so there is zero performance impact on unauthenticated visitors.
 *
 * Usage:
 * ```typescript
 * export const applicationConfigProviders = [
 *   ...otherProviders,
 *   provideProfileClaimsWatcher(),
 * ];
 * ```
 */
export function provideProfileClaimsWatcher() {
  return provideEnvironmentInitializer(() => {
    // Injecting the service will instantiate it and start the watcher
    inject(ProfileClaimsWatcherService);
  });
}
